<template>
  <el-dialog :title="title" :visible.sync="visible" width="420px" :close-on-click-modal="false" :before-close="handleClose" class="custom-confirm-dialog">
    <div class="confirm-content">
      <i class="el-icon-warning confirm-icon"></i>
      <span class="confirm-text">{{ content }}</span>
    </div>

    <span slot="footer" class="dialog-footer">
      <!-- ✅ 按钮位置已互换：确定在左，取消在右 -->
      <el-button type="primary" @click="onConfirmClick" size="mini">{{ confirmText }}</el-button>
      <el-button @click="onCancelClick" size="mini">{{ cancelText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'CustomConfirm',
    props: {
      title: { type: String, default: '提示' },
      content: { type: String, required: true },
      confirmText: { type: String, default: '确定' },
      cancelText: { type: String, default: '取消' },
      onConfirm: Function,
      onCancel: Function,
    },
    data() {
      return {
        visible: true,
      }
    },
    methods: {
      onConfirmClick() {
        this.visible = false
        this.onConfirm && this.onConfirm()
        this.$destroySelf()
      },
      onCancelClick() {
        this.visible = false
        this.onCancel && this.onCancel()
        this.$destroySelf()
      },
      handleClose() {
        this.visible = false
        this.onCancel && this.onCancel()
        this.$destroySelf()
      },
      $destroySelf() {
        this.$destroy()
        this.$el?.parentNode?.removeChild(this.$el)
      },
    },
  }
</script>

<style scoped>
  .custom-confirm-dialog ::v-deep .el-dialog__body {
    padding: 0px 20px 0px 20px;
  }

  .confirm-content {
    display: flex;
    align-items: center;
    padding: 10px 0 0px 2px;
    font-size: 14px;
  }

  .confirm-icon {
    color: #e6a23c;
    font-size: 20px;
    margin-right: 10px;
  }

  .confirm-text {
    line-height: 1.6;
  }
</style>
